export default __webpack_public_path__ + "static/media/icon-logo-medisurf.c1d4c437.svg";